import ListItem from '@material-ui/core/ListItem';
import { history } from '../history';

export default function ListItemLink(props) {
    const { href, ...rest } = props;

    return <ListItem component="div" button onClick={() => {history.push(href)}} {...rest} />;
}